module.exports = __webpack_public_path__ + "product-linentowels-medium.caa1e2de.jpg";